import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { TaskService } from '../../services/task.service';
import { ITask, TaskStatus } from '../../interfaces/task.interface';
import { AuthService } from '../../services/auth.service';
import { useToast } from '../../context/ToastContext';
import { useTranslation } from 'react-i18next';
import TaskListTable from './TaskListTable';

const PAGE_SIZE = 10;

const MyTasks: React.FC = () => {
    const toast = useToast();
    const { t } = useTranslation('task');
    const institutionId = AuthService.getSelectedInstitution()!;
    const [tasks, setTasks] = useState<ITask[]>([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchList = async (p: number) => {
        setLoading(true);
        try {
            const data = await TaskService.myTasks(institutionId, p, PAGE_SIZE);
            setTasks(data.content);
            setTotalPages(data.totalPages);
        } catch (err) {
            toast.showApiError(err, t('errors.load'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const handleStatusChange = async (task: ITask, next: TaskStatus) => {
        try {
            await TaskService.updateStatus(task.id, next);
            toast.showSuccess(t('statusUpdated'));
            fetchList(page);
        } catch (err) {
            toast.showApiError(err, t('errors.updateStatus'));
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>{t('myTasks.title')}</Typography>
            <TaskListTable
                tasks={tasks}
                loading={loading}
                page={page}
                totalPages={totalPages}
                onPageChange={setPage}
                mode="assignee"
                onStatusChange={handleStatusChange}
            />
        </Box>
    );
};

export default MyTasks;
